import React from 'react';

/**
 * Components
 */
import Button, { buttonColor, buttonType } from 'Components/Button';
import Select, { selectType } from '../../Components/Select';


export default class ManufacturerSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      manufacturer: null
    }
  }

  handleSelect = manufacturer => {
    this.setState({manufacturer});
  };

  handleSignInClick = event => {
    const {manufacturer} = this.state;
    const {handleSignInClick} = this.props;

    event.preventDefault();
    if (event.nativeEvent) event.nativeEvent.preventDefault();

    if (manufacturer) {
      event.mnfCode = manufacturer.code;
      handleSignInClick(event);
    }
  };

  render() {
    const {manufacturerList, toggleMode, requestInProcess} = this.props;

    return (
      <section className='manufacturer-select-section'>
        <form onSubmit={this.handleSignInClick}>
          <legend>Sign In as</legend>
          <div className='reminder'>
            Your account is linked to multiple organizations. Please select the one you would like to log in to:
          </div>
          <Select
            selectionList={manufacturerList}
            type={selectType.primary}
            inputClassName='_margin_top_0 _margin_bottom_20'
            iconClassName='_top_12'
            dropDownClassName='_top_39'
            placeholder='Select organization'
            itemNameIndicator='name'
            handleSelect={this.handleSelect}
          />
          <footer>
            <Button
              label='Back'
              buttonClassName='_height_40 _width_120'
              color={buttonColor.gray}
              type={buttonType.secondary}
              onClick={toggleMode}
            />
            <Button
              label='Login'
              formButtonType='submit'
              disabledWithSpinner={requestInProcess}
              buttonClassName='_height_40 _width_120'
              type={buttonType.primary}
            />
          </footer>
        </form>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/LoginScene/ManufacturerSelect.jsx